export function addLangParam(route) {
	return `/:lang?${route}`;
}
